import { FieldProps } from '../metadataFormField';
import { ReferenceField } from '../ReferenceField/referenceField';
import { SchemaField } from '../../../types/Metadata';
import { FormUpdater } from '../../../types/Field';

export const CoAuthorsField = (props: FieldProps) => {
  const { data, updater } = props;

  data.props?.coAuthors?.sort(
    (a, b) =>
      a.relationship.props.displayOrder - b.relationship.props.displayOrder
  );

  const updateDisplayOrder = coAuthorsArray => {
    if (!coAuthorsArray?.length) return [];
    let maxDisplayOrder =
      coAuthorsArray
        ?.map(c => c.relationship?.props.displayOrder)
        .reduce((max, curr) => (curr > max ? curr : max)) ?? 1;
    return coAuthorsArray
      .map(c => {
        if (c.relationship?.props.displayOrder == null) {
          c = {
            ...c,
            relationship: {
              type: 'S',
              props: {
                field: 'coAuthors',
                displayOrder: ++maxDisplayOrder
              }
            }
          };
        }
        return c;
      })
      .sort(
        (a, b) =>
          a.relationship.props.displayOrder - b.relationship.props.displayOrder
      );
  };

  const coAuthorsUpdater: FormUpdater = {
    ...updater,
    updateField: (field: SchemaField, value: any) => {
      updater.updateField(field, updateDisplayOrder(value));
    },
    update: () => {
      data.props.coAuthors = updateDisplayOrder(data.props?.coAuthors);
      updater.update();
    }
  };

  const coAuthorsProps: FieldProps = {
    ...props,
    updater: coAuthorsUpdater
  };

  return ReferenceField(coAuthorsProps);
};
